// const isDevelopmentEnv = process.env.NODE_ENV === "development";

export const log = (msg) => {
  if (true) console.log(msg);
};

export const logError = (msg?, error?: Error, errorInfo?) => {
  if (true) console.error(msg, error, errorInfo);
};
